import { useState } from 'react';
import { toast } from 'react-toastify';
import { Pager } from '../pager/pager';
import { AlbumsTable } from './albums-table';
import { useCreateAlbumMutation, useGetAlbumChildrenQuery } from './albums.api';
import { IAlbum } from '@topshots/core-models';
// import { Album } from './albums.types';

export const AlbumAlbums = ({ album }: { album: IAlbum }) => {
  const [page, setPage] = useState<number>(1);
  const [create] = useCreateAlbumMutation();
  const [perPage, setPerPage] = useState<number>(10);
  const { data, isLoading, isFetching } = useGetAlbumChildrenQuery({
    id: album._id.toString(),
    page,
    perPage,
  });
  if (isLoading || isFetching) return <span>loading...</span>;
  return (
    <>
      <AlbumsTable
        albums={data?.data ?? []}
        onCreate={async (name) => {
          await create({
            parent_id: album._id.toString(),
            name: name,
            event_id: album.event_id,
            ancestor_ids: [...(album.ancestor_ids ?? []), album] as IAlbum[],
          });
          toast.success('Album created');
        }}
      />
      <Pager
        onNext={() => {
          setPage(page + 1);
        }}
        onPrevious={() => {
          setPage(page - 1);
        }}
        onPageSelected={(selected) => {
          setPage(selected);
        }}
        onPerPageChange={(selected) => {
          setPerPage(selected);
          setPage(1);
        }}
        page={page}
        perPage={perPage}
        totalPages={data?.totalPages ?? 1}
      />
    </>
  );
};
